import { all, call, put, takeLatest } from "redux-saga/effects";
import { GUI_TIN_NHAN } from "actions/GuiTinNhan/actionTypes";
import { guiTinNhanSuccess, guiTinNhanFailure } from "actions/GuiTinNhan";
import GuiTinNhanApi from "service/guiTinNhanApi";
import { pushNotification } from "utils/notifications";

function* guiTinNhan(action) {
  try {
    const response = yield call(GuiTinNhanApi.guiTinNhan, action.dataPost);
    if (response.ok) {
      if (response.data.Error) {
        yield put(guiTinNhanFailure(response.data));
        pushNotification(response.data.Message, "error", "TOP_CENTER", 2000);
      } else {
        yield put(guiTinNhanSuccess(response.data));
        pushNotification(response.data.Message, "success", "TOP_CENTER", 2000);
        action.callback();
      }
    } else {
      pushNotification("Lỗi xảy ra", "error", "TOP_CENTER", 1000);
      yield put(guiTinNhanFailure());
    }
  } catch (error) {
    yield put(guiTinNhanFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GUI_TIN_NHAN, guiTinNhan);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
